import { LoincCodingCode } from "src/constants/fhir";
import { ParsedObservationData } from "src/lib/fhir";
import { LabResultDeleteCubit } from "src/state/LabResultsCubit/LabResultDeleteCubit";
import { Blac } from "blac-next";

/**
 * Lists of the observation codes where values might be deleted by the member.
 * Provides the delete function for the code as well.
 */
export const DELETABLE_LAB_CODES: {
  readonly [key in LoincCodingCode]?: (
    data: ParsedObservationData
  ) => Promise<void>;
} = {
  [LoincCodingCode.weight]: async ({ id: observationId }) => {
    const { deleteLabResultWeight } = Blac.getBloc(LabResultDeleteCubit);
    void deleteLabResultWeight({ observationId });
  }
} as const;
